import styled, { css } from 'styled-components';
import { theme } from 'styles';
import { Flex } from 'UI';

const cssActiveCategory = css`
  background-color: ${theme.color.white};
  border-top: solid 2px ${theme.color.blue};
`;

const cssActiveSubCategory = css`
  border-color: ${theme.color.blue};
`;

export const QUICK_ACCESS_CATEGORY_HEIGHT = 72;
const QUICK_ACCESS_ARROW_SLOT_WIDTH = 48;

export const QuickAccessBar = styled(Flex)`
  width: 100%;
  background-color: ${theme.color.grey90};
  flex-direction: row;
  align-items: stretch;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
`;

export const QuickAccessScrollWrapper = styled.div<{ $centered?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
`;

export const QuickAccessScrollArea = styled.div<{ $centered?: boolean }>`
  display: flex;
  width: ${({ $centered }) => ($centered ? 'auto' : '100%')};
  min-width: 0;
  min-height: ${QUICK_ACCESS_CATEGORY_HEIGHT}px;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const QuickAccessScrollContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
`;

export const QuickAccessArrowSlot = styled.div<{ $side: 'left' | 'right' }>`
  position: relative;
  flex-shrink: 0;
  width: ${QUICK_ACCESS_ARROW_SLOT_WIDTH}px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: ${QUICK_ACCESS_CATEGORY_HEIGHT}px;
  background: ${({ $side }) =>
    $side === 'left'
      ? `linear-gradient(to right, ${theme.color.grey90} 30%, rgba(230, 230, 230, 0.85) 100%)`
      : `linear-gradient(to left, ${theme.color.grey90} 30%, rgba(230, 230, 230, 0.85) 100%)`};
  z-index: 2;

  [data-cy='quick-access-scroll-back'],
  [data-cy='quick-access-scroll-forward'] {
    transition: opacity 0.2s ease;

    &:hover {
      background-color: transparent !important;
      filter: none;
      opacity: 0.55;
    }
  }
`;

export const CategoryFlex = styled(Flex)<{ isActive: boolean }>`
  ${({ isActive }) => isActive && cssActiveCategory};
  :hover {
    background-color: ${theme.color.white};
    cursor: pointer;
  }
`;

export const SFlex = styled(Flex)`
  padding: 15px;
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    flex-shrink: 0;
  }
`;

export const SubCategory = styled.div<{ isActive: boolean }>`
  height: 33px;
  padding: 0 10px 0 10px;
  border-radius: 16px;
  border: solid 1px ${theme.color.brand_black};
  ${({ isActive }) => isActive && cssActiveSubCategory};
  :hover {
    cursor: pointer;
  }
`;
